import
  React, {
  useContext
} from 'react';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  JourneyProvider,
  Text,
  VContainerVH,
  VFillContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  DrupalProvider
} from 'providers';

import {
  FeedProvider
} from '../providers';

import {
  ActionCardList,
  AdSlot,
  BackButton,
  Hero,
  SecondaryButton
} from 'components';

import {
  AdNames,
  CacheKeys,
  CustomColors,
  OriginContexts
} from '../../../constants';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  getAppId,
  hasAppId,
  isEqual,
  openDeeplink,
  useRedirectHandler
} from 'helpers';

import {
  AppContext
} from 'context';

export const RssContentUI = props => {

  const [
    state,
    setState
  ] = React.useState({
    feeds: null,
    error: null,
    loading: true,
    rssFeeds: null
  });

  const location = useLocation();
  const history = useHistory();
  const redirectHandler = useRedirectHandler();
  const { config } = useContext(AppContext);

  const urlParams = new URLSearchParams(location?.search);

  RssContentUI.pageName = `cbu: connectu: news feed: ${urlParams.get('category')}: content page`;

  const context = JourneyProvider.get(CacheKeys.ConfigContext, 'value', '');

  const getRssFeeds = async () => {

    const rssFeeds = await DrupalProvider.getCachedItem('rss_feeds', null, DrupalProvider.getRssFeeds);

    if (!rssFeeds.ok) {
      setState({
        ...state,
        loading: false,
        error: rssFeeds.error
      });
    }

    setState({
      ...state,
      rssFeeds: rssFeeds.result
    });

    const response = await FeedProvider.getCachedItem(`batch--feeds--${urlParams.get('category')}`);

    if (!response || !response.ok || !response?.result) {

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: true
      }));
      return;
    }

    let feeds = [];

    for (const feed of response.result) {

      for (let article of feed?.items) {

        article.company = feed.name;
        feeds.push(article);
      }
    }

    setState(prevState => ({
      ...prevState,
      loading: false,
      feeds: feeds
    }));
  };

  React.useEffect(() => {

    getRssFeeds();

  }, [ urlParams.get('newsId') ]);

  const feed = state.feeds?.find(feed => feed?.newsArticleUrl === urlParams.get('newsId'));

  const [ month, date, year ]  = new Date(feed?.date).toLocaleDateString('en-US').split('/');

  const getFeedImage = () => {

    const base64Image = FeedProvider.getCachedItem(`${CacheKeys.FeedImage}${feed?.imageId}`)?.result;

    if (feed?.imageId && base64Image) {
      return `data:image/png;base64,${base64Image}`;
    }

    return `${Environment.current?.drupalBaseUrl}${state.rssFeeds?.find(drupalFeed => drupalFeed?.title === urlParams.get('category'))?.feeds?.find(drupalFeed => drupalFeed?.name === feed?.company)?.defaultImage}`;
  };

  const feeds = state.feeds?.filter(feed => feed.newsArticleUrl !== urlParams.get('newsId'));

  return (

    <VFillContainer>
      <HandleRender
        isLoading={state.loading}
        isError={state.error}>

      { state.feeds && feed &&
        <>
          <AdSlot
            margin={'16px 0'}
            adId={AdNames.TopLeaderboard} />

          <Hero
            background={getFeedImage()} />

          <BackButton
            onClick={() => history.push('/home')} />

          <VFillContainer
            padding={'0 16px'} >

            <Text
              fontSize={'20px'}
              fontWeight={'bold'}
              color={CustomColors.Grey11}
              padding={'0 0 40px'}>
              {feed.title}

            </Text>

            <Text
              fontSize={'16px'}
              color={CustomColors.Grey9}
              padding={'0 0 32px'}
              whiteSpace={'pre-wrap'}>
              {`${feed.company}  ${date}/${month}/${year}`}

            </Text>

            <Text
              fontSize={'16px'}
              color={CustomColors.Grey9}>
              {feed.content}

            </Text>
          </VFillContainer>

          <VContainerVH>

            <VContainerVH
              padding={'0 28px'}
              width={'100%'}
              boxSizing={'border-box'}>

              <SecondaryButton
                margin={'32px 0 0'}
                text={'Read full story'}
                onClick={
                  isEqual(context, OriginContexts.VodaPay) && hasAppId(config, feed.company)
                    ? () => openDeeplink(getAppId(config, feed.company))
                    : () => redirectHandler(history.location, `/redirect?targetUrl=${feed.newsArticleUrl}&isZeroRated=false`, false)
                }
              />
            </VContainerVH>

            <ActionCardList
              title={'Recent Stories'}
              items={feeds.map((val) => {
                return {
                  text: val.title,
                  subText: val.company,
                  onClick: () => {

                    history.push({
                      pathname: '/news-content',
                      search: `?newsId=${encodeURIComponent(val.newsArticleUrl)}&category=${encodeURIComponent(urlParams.get('category'))}`
                    });
                  }
                };
              })}
              cardPadding={'10px 0'}/>

          </VContainerVH>
        </>
      }
      </HandleRender>
    </VFillContainer>
  );
};

RssContentUI.tagViewData = {
  page_section: 'news feed: content page'
};

export const RssContent = withScreenViewTagging(RssContentUI);
